import request from '@/utils/request'
import { removeEmptyObj } from '@/utils/common'

export function getCode() {
  return request.get('/imageCaptcha')
}

export function login(data) {
  const formData = new FormData()
  formData.append('account', data.account)
  formData.append('password', data.password)
  return request.post('/web/login', formData)
}

export function getInfo() {

  return request.get('/user/info')
}

// 用户列表
export function getUserPage(currentPage, pageSize, data) {
  return request.post(`/user/page/${currentPage}/${pageSize}`, removeEmptyObj(data))
}

// 添加用户
export function addUser(formData) {
  return request.post('/user/add', formData)
}

// 修改用户
export function editUser(formData) {
  return request.post('/user/edit', formData)
}

// 删除用户
export function removeUser(ids) {
  return request.post('/user/remove', ids)
}

// 根据id查看用户
export function getUserById(id) {
  return request.get('/user/view?id=' + id)
}

// 获取当前用户菜单
export function getUserMenus() {
  return request.get('/user/menus')
}

// 修改用户密码
export function changePassword(password) {
  const formData = new FormData()
  formData.append('password', password)
  return request.post('/user/changePassword', formData)
}

// 查询用户列表-【根据角色类型（roleType）：0=检验员，1=校对人，2=审批人】
export function getUserByRoleType(data) {
  return request.get('/user/list', {params: removeEmptyObj(data)})
}

export function getPublicKey() {
  return request.get('/web/publicKey')
}

// 判断是否填写了单位性质
export function getUnitNature() {
  return request.get('/bass/unit/require/unitNature')
}

// 获取单位性质
export function whatUnitNature() {
  return request.post('/bass/unit/get/unitNature')
}

export function updataUnitNature(data) {
  return request.post('/bass/unit/setUnitNature', {}, {params: removeEmptyObj(data)})
}

export function getEntrustedPerson(data) {
  return request.get('/user/get/entrustedPerson', {params: removeEmptyObj(data)})
}
